import { Box, Text } from '@factorialco/deprecated-design-system'

import { HelpCenterUrl } from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import { type Vendor } from '../../types'
import { type SamlForm } from '../useSamlForm'
import VendorBlock from './VendorBlock'

interface Props {
  form: SamlForm
  samlName: string
}

const Metadata = ({ form, samlName }: Props) => {
  const handleVendorSelect = (value: string) => {
    form.setFieldValue('vendor', value)
    form.setFieldValue('droppedFile', undefined)
    form.setFieldValue('metadata', undefined)
  }

  const handleFileDrop = async (file: File) => {
    const content = await file.text()
    if (!content) return // TODO: Show error toast

    form.setFieldValue('droppedFile', file)
    form.setFieldValue('metadata', content)
  }

  type VendorBlockOptions = {
    vendor: Vendor
    label: string
    helpCenterPage: HelpCenterUrl
    showName?: boolean
  }
  const vendors: VendorBlockOptions[] = [
    { vendor: 'Google', label: 'Google', helpCenterPage: 'saml_google' },
    { vendor: 'Microsoft', label: 'Microsoft', helpCenterPage: 'saml_microsoft', showName: true },
    { vendor: 'Okta', label: 'Okta', helpCenterPage: 'saml_okta', showName: true },
  ]

  return (
    <Box>
      <Box paddingBottom="s16">
        <Text.Normal size="300" color="grey800">
          {i18n.t('settings.edit_company.saml_sso.modal.metadata.description')}
        </Text.Normal>
      </Box>
      {vendors.map(({ vendor, label, helpCenterPage: helpPage, showName }) => (
        <VendorBlock
          key={vendor}
          form={form}
          vendor={vendor}
          label={label}
          helpCenterPage={helpPage}
          samlName={showName ? samlName : undefined}
          onSelect={handleVendorSelect}
          onFileDrop={handleFileDrop}
        />
      ))}
    </Box>
  )
}

export default Metadata
